import React from 'react';

interface SuiteAddedIllustrationProps {
  className?: string;
}

const SuiteAddedIllustration = ({ className }: SuiteAddedIllustrationProps) => (
  <svg
    className={className}
    width="132"
    height="132"
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <rect
      x="28"
      y="22"
      width="50"
      height="74"
      rx="6"
      fill="#E0F5F5"
      stroke="#00848E"
      strokeWidth="2.5"
    />
    <rect x="37" y="32" width="12" height="12" rx="2" fill="#00848E" />
    <rect x="57" y="32" width="12" height="12" rx="2" fill="#00848E" />
    <rect x="37" y="52" width="12" height="12" rx="2" fill="#00848E" />
    <rect x="57" y="52" width="12" height="12" rx="2" fill="#00848E" />
    <rect x="46" y="74" width="14" height="22" rx="2" fill="#00848E" />
    <circle cx="86" cy="84" r="20" fill="#48C1BF" />
    <path
      d="M77 84.5l6 6 12-12"
      stroke="#fff"
      strokeWidth="3.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SuiteAddedIllustration;
